/**
 * Used by `ng build --configuration=development` and `ng serve --configuration=development`.
 * API host is the shared dev stack — not every merged admin-api route (e.g. internal-accounting) may exist there.
 * For local smart-dining-admin-api features, use `environment.local.ts` via `ng serve --configuration=local`.
 */
import { DEV_DEMO_RELEASE_OVERRIDES } from '../app/config/dev-demo-release-overrides';

export const environment = {
  production: false,
  requireMfaForAdminLogin: false,
  adminTrustedDeviceRememberDays: 14,
  offerAdminLoginTrustedDevice: true,
  API_ENDPOINT: "https://dev-api.smartdining.co/",
  ENCRYPT_SECRET_KEY: "GoSm@rtD!n!ng@bt",
  googleMapsApiKey: 'AIzaSyAlee97PLNsJBx_Rtz3kFVk--y9mYn7yQE',
  googleMapsMapId: '4dcd3741dcec2c3975fbb0d8',
  guestAppUrl: 'https://dev.smartdining.co',

  awss3config: {
    BUCKET_NAME: "app-image-storage-develop",
    USER_IMAGES_DIR: "user/",
    CATEGORY_IMAGES_DIR: "category/",
    MENU_IMAGES_DIR: "menu/",
    IDENTITY_POOL_ID: "",     // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    IDENTITY_POOL_REGION: "us-east-2" // OPTIONAL - Amazon Cognito Federated Identity Pool Region
  },

  cloudinary: {
    cloudName: "",
    app_upload_preset: "",
    guest_upload_preset: "",
    restaurant_upload_preset: "",
    menu_upload_preset: ""
  },

  awsServerlessImageHandler: {
    cloudFrontUrl: "https://",
  },

  awscognitoconfig: {
    aws_project_region: 'us-east-2',
    aws_cognito_region: 'us-east-2',
    aws_user_pools_id: 'us-eastc',
    aws_user_pools_web_client_id: '',
    federationTarget: 'COGNITO_USER_POOLS',
    mandatorySignIn: true,  // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    authenticationFlowType: "USER_SRP_AUTH", // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
  },

  elasticappsearch: {
    baseUrl:
      'https://',
    endpoint: '/api/as/v1/',
    apiKey: 'search',
    appSearchEngine: 'customers',
  },

  ordersOverdueTime: 300, // 5 minutes

  socialHub: {
    enabled: false,
    smartDiningBrandCompanyUid: '',
    devHeaders: {},
  },

  internalAccounting: {
    devHeaders: {} as Record<string, string>,
  },

  brandAmbassadors: {
    useBrowserStore: false,
    referralLandingBaseUrl: 'https://smartdining.co/join',
    devHeaders: {} as Record<string, string>,
  },

  hrAdmin: {
    devHeaders: {} as Record<string, string>,
  },

  homeHeroVideoUrl: '',
  pricingOverviewVideoUrl: '',

  /** Must match API PLATFORM_INITIAL_SETUP_SECRET for greenfield /platform-setup (dev stack only). */
  platformInitialSetupSecret: 'local-dev-greenfield-setup-change-me',

  /** Local owner app (`web-restaurant-app`); align with `ng serve` port. */
  ownerPortalBaseUrl: 'http://localhost:6001',

  internalCrmDemoSalesRelease: { ...DEV_DEMO_RELEASE_OVERRIDES },

};
